module.exports = __webpack_public_path__ + "img/movie4.f7ac8f04.png";